import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Container, Content, Notification } from './styled';
import {
    New,
    Open,
    My,
    Close,
    Group,
    MenuAdmin,
    WaitingRoom,
    Reports
} from './content';
import { Tabs, Tab } from '../../../../components';
import { useAuth } from '../../../../contexts/auth';
import { useChat } from '../../../../contexts/chat';
import { useNotification } from '../../../../contexts/notification';

export function TabList(props) {
    const {
        loadingAccessLevel,
        accessLevel,
        orderList,
        SelectOrderList
    } = props;

    const history = useHistory();

    const { tokenReports, onSignInReports } = useAuth();

    const {
        contNewChats,
        contMyChats,
        contOpenChats,
        contMyGroup,
        contMyChatsClose,
        myChatsNotification
    } = useNotification();

    const { waitingRoomLength, resetChat } = useChat();

    useEffect(() => {
        if (accessLevel?.length > 0) {
            onSignInReports();
        }
    }, [accessLevel]);
    function handSelectTab(order) {
        if ((orderList < 5) && (order > 5)) {
            resetChat();
        }
        if ((orderList > 5) && (order <= 5)) {
            history.push('/window');
        }
        SelectOrderList(order);
    };

    return (
        <Container>
            {!loadingAccessLevel &&
                <div className='tabs--'>
                    <Tabs>
                        <Tab
                            onClick={() => handSelectTab(1)}
                            className={parseInt(orderList) === 1 && 'selected'}
                        >
                            Meus
                            <Notification>
                                <span
                                    className={
                                        `white 
                                ${contMyChats > 100 && 'bigger'}
                                `
                                    }>{contMyChats}</span>
                                {parseInt(myChatsNotification.length) > 0 && contMyChats > 0 &&
                                    <span className='green'>
                                        {parseInt(myChatsNotification.length)}
                                    </span>
                                }
                            </Notification>
                        </Tab>
                        {accessLevel?.includes('NOVOS') &&
                            <Tab

                                onClick={() => handSelectTab(0)}
                                className={parseInt(orderList) === 0 && 'selected'}
                            >
                                Novos
                                <Notification>
                                    <span
                                        className={
                                            `white 
                                ${contNewChats > 100 && 'bigger'}
                                `
                                        }
                                    >
                                        {contNewChats}
                                    </span>
                                </Notification>
                            </Tab>
                        }
                        {accessLevel?.includes('GRUPO') &&
                            <Tab
                                onClick={() => handSelectTab(4)}
                                className={parseInt(orderList) === 4 && 'selected'}
                            >
                                Setores
                                <Notification>
                                    {contMyGroup !== 0
                                        ? <span
                                            className={
                                                `white ${contMyGroup > 100 && 'bigger'}`
                                            }
                                        >
                                            {contMyGroup}
                                        </span>
                                        : <span className={`white`}>{0}</span>
                                    }
                                </Notification>

                            </Tab>
                        }
                        {accessLevel?.includes('SALA_ESPERA') &&
                            <Tab
                                onClick={() => handSelectTab(5)}
                                className={parseInt(orderList) === 5 && 'selected'}
                            >
                                Sala de Espera
                                <Notification>
                                    {waitingRoomLength !== 0
                                        ? <span
                                            className={
                                                `white ${waitingRoomLength > 100 && 'bigger'}`
                                            }
                                        >
                                            {waitingRoomLength}
                                        </span>
                                        : <span className={`white`}>{0}</span>
                                    }
                                </Notification>

                            </Tab>
                        }
                        {accessLevel?.includes('ABERTOS') &&
                            <Tab
                                onClick={() => handSelectTab(2)}
                                className={parseInt(orderList) === 2 && 'selected'}
                            >
                                Abertos
                                <Notification>
                                    <span
                                        className={
                                            `white
                                 ${contOpenChats > 100 && 'bigger'}
                                 `}
                                    >
                                        {contOpenChats}
                                    </span>
                                </Notification>
                            </Tab>
                        }
                        {accessLevel.length !== 0 && accessLevel[0] !== undefined &&
                            <Tab
                                onClick={() => handSelectTab(3)}
                                className={parseInt(orderList) === 3 && 'selected'}
                            >
                                Fechados
                                <Notification>
                                    {contMyChatsClose !== 0
                                        ? <span
                                            className={
                                                `white 
                                    ${contMyChatsClose > 100 && 'bigger'}
                                    `
                                            }
                                        >
                                            {contMyChatsClose}
                                        </span>
                                        : <span>{'...'}</span>
                                    }
                                </Notification>
                            </Tab>
                        }
                        {accessLevel?.includes('RELATORIOS') &&
                            <Tab
                                onClick={() => handSelectTab(7)}
                                className={`${!tokenReports && 'adminTabLoading'} ${parseInt(orderList) === 7 && 'selected'}`}
                            >
                                Relatórios
                            </Tab>
                        }
                        {accessLevel?.includes('ADMINISTRADOR') &&
                            <Tab
                                onClick={() => handSelectTab(6)}
                                className={`${parseInt(orderList) === 6 && 'selected'}`}
                            >
                                Administrador
                            </Tab>
                        }
                    </Tabs>
                </div>
            }
            <Content>
                <My isVisibility={parseInt(orderList) === 1} />
                <Close isVisibility={parseInt(orderList) === 3} />
                {accessLevel?.includes('NOVOS') &&
                    <New isVisibility={parseInt(orderList) === 0} />
                }
                {accessLevel?.includes('GRUPO') &&
                    <Group
                        isVisibility={parseInt(orderList) === 4}
                        allowAddInRoom={accessLevel?.includes('SALA_ESPERA')}
                    />
                }
                {accessLevel?.includes('SALA_ESPERA') &&
                    <WaitingRoom isVisibility={parseInt(orderList) === 5} />
                }
                {accessLevel?.includes('ABERTOS') &&
                    <Open isVisibility={parseInt(orderList) === 2} />
                }
                {accessLevel?.includes('ADMINISTRADOR') && parseInt(orderList) === 6 &&
                    <MenuAdmin />
                }
                {accessLevel?.includes('RELATORIOS') &&
                    <Reports isVisibility={parseInt(orderList) === 7} />
                }
            </Content>
        </Container>
    );
}